/* src/app/component/viewer/viewer.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}
img {
  display: block;
  margin: auto;
  max-width: 60%;
  height: auto;
}
.element {
  max-width: 100%;
  max-height: 60%;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  padding: 1rem;
  background-color: white;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.close-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
  font-size: 1.5rem;
}
iframe {
  width: 100%;
  height: 80%;
  border: none;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
.close-button {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 0.25rem;
}
.close-button:hover {
  background-color: #0056b3;
}
:host {
  display: block;
  width: 100%;
  height: 100%;
}
.pdf-container {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=viewer.component-A5JALRIR.css.map */
